export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_6.1-56c8661c3d5548e0108fd0cb7a1a4c77.svg";